import { Link } from "react-router-dom";
import Dropdown from "./Dropdown";
import ThreeDotsIcon from "./ThreeDotsIcon";
import { useCallback, useState } from "react";
import { useClickOutside } from "../../../app/layouts/Header";

const MiniMenu: React.FC = () => {
  const [open, setOpen] = useState(false);
  const close = useCallback(() => setOpen(false), []);
  const ref = useClickOutside(close);

  return (
    <div ref={ref} className="relative h-full flex items-center">
      <button
        onClick={() => setOpen((v) => !v)}
        className={[
          "flex flex-col items-center justify-center h-full transition-colors duration-200 cursor-pointer border-0",
          "px-4 md:px-5 xl:px-7",
          "xl:border-l-2 xl:border-r-2 xl:border-[#f5f6f9]",
          open
            ? "bg-[#3b519c] text-white"
            : "bg-transparent text-[#26295e] hover:bg-[#f5f6f9]",
        ].join(" ")}
        aria-label="Menu"
        aria-expanded={open}
      >
        <ThreeDotsIcon className="w-[6px] h-5 md:w-[7px] md:h-6" />
      </button>

      <Dropdown isOpen={open} className="w-[280px]" arrowRight={16}>
        <ul className="p-2.5 list-none m-0">
          <li className="border-b border-[#ddd]">
            <Link
              to="/help"
              onClick={close}
              className="relative block py-4 pl-7 text-[#202020] text-sm font-medium no-underline hover:text-[#3b519c] transition-colors"
              style={{ fontFamily: "var(--font-primary)" }}
            >
              <span className="absolute top-5 left-2 w-2.5 h-2.5 rounded-full bg-[#26295e]" />
              Technical Support
            </Link>
          </li>
        </ul>
      </Dropdown>
    </div>
  );
};

export default MiniMenu;
